var React = require('react');

function YandexInternational (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"}));
}

YandexInternational.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = YandexInternational;

YandexInternational.default = YandexInternational;
